import { gql } from '@apollo/client';
import { logger } from 'client/utils/logger/logger';
import { withMetrics } from 'client/data/api/api-metrics';
import { createModelSegment } from 'client/data/luckdragon/segment';
import { EdmundsGraphQLFederation } from 'client/data/graphql/graphql-client';
import { VisitorModel } from 'client/data/models/visitor';

const getDealScorePath = ({ make, model, year }) => `dealScore["${make}"]["${model}"]["${year}"]`;

export const LeaseDealCheckerPaths = {
  getDealScorePath,
};

export const LeaseDealCheckerModel = createModelSegment('leaseDealChecker', [
  /**
   * @see getDealScorePath
   */
  {
    path: 'dealScore["{make}"]["{model}"]["{year}"]',
    async update(value, match, context) {
      if (!value) {
        return {};
      }

      const { make, model, year } = value;
      const { zipCode } = await context.resolveValue('location', VisitorModel);

      try {
        const graphqlResponse = await withMetrics(EdmundsGraphQLFederation, context).query(
          gql`
            query EdmundsQuery($leaseDealFilters: LeaseDealFilters!) {
              leaseDeals(leaseDealFilters: $leaseDealFilters) {
                aggregation {
                  topDealsByModel(sorts: { order: ASC }) {
                    deal {
                      modelYear {
                        id
                      }
                      activeListingStats {
                        effectivePaymentMedian
                      }
                      inventoryBodyType
                    }
                  }
                }
              }
            }
          `,
          {
            leaseDealFilters: {
              makes: { in: [make] },
              models: { in: [model] },
              years: { in: [Number(year)] },
              zip: zipCode,
            },
          }
        );

        const firstDeal = graphqlResponse?.leaseDeals?.aggregation?.topDealsByModel?.[0]?.deal;
        return {
          bodyType: firstDeal?.inventoryBodyType,
          effectivePaymentMedian: firstDeal?.activeListingStats?.effectivePaymentMedian,
        };
      } catch (error) {
        logger.error('lease-deal-checker.js - dealScore update - failure', error);
        return {};
      }
    },
  },
]);
